import { render, staticRenderFns } from "./WidgetProductReviewsHorizontalScrollPc.vue?vue&type=template&id=63ef9621"
import script from "./WidgetProductReviewsHorizontalScrollPc.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsHorizontalScrollPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports